export default {
  namespaced: true,
  state: {
    hopscotch: null,
    tours: {
      'map': {
        id: "map",
        zindex:1000,
        showPrevButton: true,
        onEnd: function (e) {
          var node = document.querySelector('.form')
          node.classList.remove('expand')
        },
        steps: [
          {
            title: "Overview all stations",
            content: "blabla",
            target: document.querySelector('.leaflet-overview'),
            placement: "right",
            
          },{
          title: "My Header",
          content: "This is the header of my page.",
          target: document.querySelector('.gnss-menu'),
          xOffset: "-200px",
          onShow: function (e) {
            var node = document.querySelector('.gnss-menu .gnss-shortcut')
            setTimeout(function () {
              node.classList.add('selected')
            }, 200)
            
          },
          placement: "left"
        },
        {
          title: "layer",
          content: "blabla",
          target: document.querySelector('.leaflet-control-layers-toggle'),
          placement: "right",
          onNext: function (e) {
            var node = document.querySelector('.form')
            node.classList.add('expand')
          }
          
        },
        {
          title: "My content",
          content: "Here is where I put my content.",
          target: document.querySelector('.form .gnss-shortcut'),
          placement: "left",
         // xOffset: '-350px',
         
          delay: 400,
          showPrevButton: true,
          onShow: function (e) {
            var node = document.querySelector('.form')
            node.classList.add('expand')
          },
          onNext: function (e) {
            var node = document.querySelector('.form')
            node.classList.remove('expand')
          },
          onPrev: function (e) {
            var node = document.querySelector('.form')
            node.classList.remove('expand')
          }
        }
        ]
      }
    }
  },
  mutations: {
    start(state, name) {
      console.log(state.tours[name])
      if (!state.hopscotch) {
        import('hopscotch').then(module => {
          state.hopscotch = module.default
          state.hopscotch.startTour(state.tours[name],0);
         
        })
      } else {
        state.hopscotch.startTour(state.tours[name],0);
      }
    }
  }
}